/** @file Builds the ToolContext a tool sees from the runtime state (null without a compiled rig). */
import type { Camera } from '@pose2d/geometry/types';
import { compiledStore } from '../../stores/compiledStore';
import { playheadStore } from '../../stores/playheadStore';
import { selectionStore } from '../../stores/selectionStore';
import { toolStore } from '../../stores/toolStore';
import { poseInputOf } from './poseInputOf';
import type { RuntimeState } from './runtimeState';
import { poseScene } from './scene/poseScene';
import type { ToolContext } from './viewportTypes';
import { viewportStore } from './viewportStore';

/** setPreview merges over `s.base` (the unkeyed pose); every callback marks the frame dirty. */
export function toolContextOf(s: RuntimeState, camera: Camera): ToolContext | null {
  const { json, atlas } = compiledStore.getState();
  const { scene, maps, doc } = s;
  if (scene === null || maps === null || doc === null || json === null || atlas === null) return null;
  const tool = toolStore.getState();
  return {
    doc, data: scene.data, pose: scene.pose, maps, camera, skeleton: scene.skeleton, json, atlas, tool,
    playhead: playheadStore.getState(), selection: selectionStore.getState(), grid: doc.view.grid, snap: tool.snap || doc.view.grid.snap,
    setPreview: (values) => { s.preview = new Map([...s.base, ...values]); s.dirty = true; },
    setGizmo: (drawing) => { s.gizmo = drawing; s.dirty = true; },
    notify: (notice) => { viewportStore.setState({ notice }); },
    repose: () => { poseScene(scene, poseInputOf(s, scene.data)); },
  };
}
